<h1 mat-dialog-title>{{title}}</h1>

<div mat-dialog-content *ngIf="data" [innerHTML]="message"></div>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onNoClick()">{{type === 'CONFIRM' ? 'CONFIRM' : 'Okay'}}</button>
  <button *ngIf="type === 'CONFIRM'" mat-button (click)="onNoClick(false)">CANCEL</button>
</div>
